import { render } from "./CIS-Controls-Navigator-Listing.vue?vue&type=template&id=324ead25&scoped=true"
import script from "./CIS-Controls-Navigator-Listing.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Navigator-Listing.vue?vue&type=script&lang=js"

import "./CIS-Controls-Navigator-Listing.vue?vue&type=style&index=0&id=324ead25&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324ead25"]])

export default __exports__